const production = {
    api: {
        baseUri: "https://api.paguefreeflow.com.br/webapi",
        apiKey: "fsPj1oWQFp1gk43fIb6F24wR9aNi0pmV29oMNNk2",
        companyIdentification: "CGMP",
        channel: "16",
        userIdentification: "ffap",
        merchantDefinedInformation: {
            channel: "APP-RecargaPreManual"
        },
        cybersource: {
            orgId: "k8vif92e",
            merchantId: "semparar_br",
        },
    },
    pci: {
        url: 'https://cyptgw.fleetcor.com.br',
        key: '99374fbe8588c6cb1fc1a04ccf0f38617ef72d3b2526393830a3dadd36462d87',
    },
}

export default production;